import { render } from "./newstate.vue?vue&type=template&id=5b39dd85"
import script from "./newstate.vue?vue&type=script&lang=js"
export * from "./newstate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__